import React from "react";
import {
  Form,
  Col,
  Row,
  Button,
  InputGroup,
  FormControl,
  Carousel
} from "react-bootstrap";
import Select from "react-select";
import _ from 'lodash';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink, faLock, faList, faCalendarWeek } from "@fortawesome/free-solid-svg-icons";
import { shareItem } from "../../actions/items";
import imgCamelLogo from '../../assets/images/main-logo-white.png';

import "./ShareItemForm.scss";


const ShareItemForm = props => {
  const [recipient, setRecipient] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [shortInfo, setShortInfo] = React.useState(null);
  const [ctaValue, setCtaValue] = React.useState(null);
  const [currentIndex, setCurrentIndex] = React.useState(0)
  

  const shareButtonRef = React.createRef();

  
  const DESCRIPTION_INDEX = {
    "RECIPIENT": 0,
    "PASSWORD": 1,
    "CTA": 2,
    "BRANDING": 3
  }
  const onSubmit = (e) => {
    e.preventDefault()
    onClickShareWithRecipient(e)
    props.onClose();
  }

  /**
   * Handle the short URL share with a recipient noted
   * along with the short URL
   * @param {Object} e 
   * @param {String} id itemId 
   */
  const onClickShareWithRecipient = async (e) => {
    // console.log({functionName: "ShareItemForm:onClickShareWithRecipient", e});
    e.stopPropagation();
    // dismiss overlay
    document.body.click();
    const sharedTo = recipient.trim();
    
    // just copy link if no recipient
    if (!sharedTo) {
      // onClickShare(e);
      return;
    }

    // clear alert status
    if (shortInfo) {
      shortInfo.didAlert = false;
    }

    const shareInfo = {
      id: props.itemId,
      sharedTo,
      shortUrl: props.shortUrl,
      itemType: props.itemType,
      ctaId: ctaValue ? ctaValue.value : ''
    }

    if (password) {
      shareInfo.password = password
    }
    // console.log({info: "ShareItemForm:onClickShareWithRecipient", shareInfo, props, dispatch: props.dispatch});
    props.dispatch(shareItem(shareInfo));

    if (props.changeNotificationPermission) {
      props.changeNotificationPermission();
    }
  }

  const handleSelect = (selectedIndex, e) => {
    setCurrentIndex(selectedIndex)
  }

  const renderDescription = () => {
    switch (currentIndex) {
      case DESCRIPTION_INDEX.PASSWORD:
        return 'Setting a password will secure the link and prevent unauthorized access'
      case DESCRIPTION_INDEX.CTA:
        return 'Adding a call to action will provide a next step action for the recipient'
      case DESCRIPTION_INDEX.BRANDING:
        return 'Adding branding will customize the logo element used on the share for the recipient'
      case DESCRIPTION_INDEX.RECIPIENT:
      default:
        return 'Personalized links will enable follow up notifications and metrics based on individual recipient interaction'
    }
  }

  const { itemId, ctaList, itemType, enableCTA, itemTitle } = props

  // CTAs
  const sortedCtaList = _.sortBy(ctaList, ['message']);
  // Only include the CTA item if the list is not empty
  const addCTAs = enableCTA && !_.isEmpty(sortedCtaList);


  return (
    <Form className="share-item-form" onSubmit={onSubmit}>
      <div className="form-header">
        <img src={imgCamelLogo} alt="logo" />
      </div>
      <div className="p-4">
        <h3>Create Personalized Link</h3>
        <div className="note-text">{renderDescription()}</div>
        <div className="recipient-title">{itemTitle}</div>

        <div className="carousel-container">
          <Carousel
            interval={null}
            wrap={false}
            nextIcon={<span aria-hidden="true" className="carousel-control-next-icon" />}
            prevIcon={<span aria-hidden="true" className="carousel-control-prev-icon" />}
            activeIndex={currentIndex}
            onSelect={handleSelect}
          >
            <Carousel.Item>
              <div className="recipient-title">Recipient</div>
              <InputGroup size="sm">
                <FormControl
                  ref={shareButtonRef}
                  aria-label="Recipient"
                  aria-describedby="Recipient"
                  placeholder="Recipient..."
                  value={recipient}
                  className="share-recipient"
                  onChange={(e) => setRecipient(e.target.value)}
                  onKeyPress={(event) => {
                    if (event.key === "Enter") {
                      onClickShareWithRecipient(event);
                    }
                  }}
                />
              </InputGroup>
            </Carousel.Item>

            {/* <Carousel.Item>
              <div className="recipient-title">Password</div>
              <InputGroup size="sm">
                <FormControl
                  ref={shareButtonRef}
                  aria-label="Password"
                  aria-describedby="Password"
                  placeholder="********"
                  type="password"
                  autoComplete="new-password"
                  value={password}
                  className="share-recipient"
                  onChange={(e) => setPassword(e.target.value)}
                />
              </InputGroup>
            </Carousel.Item> */}

            {addCTAs && (
              <Carousel.Item>
                <div className="recipient-title">Call To Action</div>
                <div className="mt-2 cta-dropdown">
                  <Select
                    options={sortedCtaList.map(ct => ({ value: ct.id, label: ct.message }))}
                    classNamePrefix="cta_"
                    placeholder="Select CTA"
                    onChange={value => setCtaValue(value)}
                    size={14}
                    value={ctaValue}
                  />
                </div>
              </Carousel.Item>
            )}
          </Carousel>
        </div>
        <Form.Group as={Row} controlId="actionsContainer" >
          <Col className="d-flex justify-content-start actions-container">
            {/* <FontAwesomeIcon
              className={`action-icon${currentIndex === 0 ? ' active' : ''}`}
              icon={faLink}
              onClick={() => setCurrentIndex(0)}
            /> */}
            {/* <FontAwesomeIcon
              className={`action-icon${currentIndex === 1 ? ' active' : ''}`}
              icon={faLock}
              onClick={() => setCurrentIndex(1)}
            /> */}
            {/* <FontAwesomeIcon icon={faCalendarWeek} />
            <FontAwesomeIcon icon={faList} /> */}
            {enableCTA && (
              <div
                className={`cta-text action-icon${currentIndex === 2 ? ' active' : ''}`}
                onClick={() => setCurrentIndex(2)}
              >
                CTA
              </div>
            )}
          </Col>
          <Col className="d-flex justify-content-end actions-container">
            <Button variant="outline-danger" size="sm" onClick={props.onClose}>CANCEL</Button>
            <Button
              type="submit"
              variant="outline-danger"
              size="sm"
              disabled={!recipient}
            >
              CREATE
            </Button>
          </Col>
        </Form.Group>
      </div>
    </Form>
  )
}

export default ShareItemForm;
